import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// type Props = {
//     // from search-new/components/Inline/LongInlinePresentation.js
//     appearanceValues: Object,
//     inlineId: number,
//     hide: boolean,
//     pdfUrl: string,
//     uniqueFlvId: string,
//     updateInlineAppearance: () => mixed,
//     onClick: () => mixed,
// };

/** render the button that will expand the Inline onclick */
const ExpandControl = (props) => {
    // determine whether or not the current Inline has been expanded (from the store)
    const expandState = (e) => {
        // prevent href and Segue from firing, respectively
        e.preventDefault()
        e.stopPropagation()
        if (props.onClick && !props.appearanceValues.get("expanded")) {
            props.onClick()
        }
        return props.updateInlineAppearance(props.uniqueFlvId, props.inlineId, {
            expanded: !props.appearanceValues.get("expanded"),
        })
    }

    // the hasExpandControl boolean is set in the Inline Component's 'componentDidMount' function according to the
    //      rendered height of the description (thirdLineData) element
    return (
        !props.hide && (
            <div className="link-controls">
                {
                    <object>
                        <a
                            className={classNames("expand-control", { "has-pdf": props.pdfUrl })}
                            onClick={expandState}
                            href={props.pdfUrl}
                        >
                            <i
                                className={`fa ${
                                    props.appearanceValues.get("expanded") ? "fa-angle-up" : "fa-angle-down"
                                }`}
                            />
                            {` See ${props.appearanceValues.get("expanded") ? "Less" : "More"}`}
                        </a>
                    </object>
                }
            </div>
        )
    )
}

ExpandControl.propTypes = {
    // from search-new/components/Inline/LongInlinePresentation.js
    appearanceValues: PropTypes.object,
    inlineId: PropTypes.number,
    pdfUrl: PropTypes.string,
    uniqueFlvId: PropTypes.string,
    updateInlineAppearance: PropTypes.func,
}

export default ExpandControl
